module.exports = __webpack_public_path__ + "img/jixie.c5f915d6.svg";